//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"AnyCrossSection",1,0],[0,"AnyLongitudinalSection",1,0],[0,"ContactingFeature",1,0],[0,"DatumTranslation",1,0],[0,"FreeState",1,0],[0,"LeftBracket",1,0],[0,"Letter",1,0],[0,"MajorDiameter",1,0],[0,"MaterialCondition",1,0],[0,"MinorDiameter",1,0],[0,"OrientationConstraint",1,0],[0,"PitchDiameter",1,0],[0,"Projected",1,0],[0,"RightBracket",1,0],[0,"SituationFeatureLine",1,0],[0,"SituationFeaturePlane",1,0],[0,"SituationFeaturePoint",1,0],[0,"VariableDistance",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.DatumReferenceBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.DatumReferenceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.DatumReferenceBuilder.DatumReferenceMaterialCondition = Object.freeze({
    "None" : "None", "LeastMaterialCondition" : "LeastMaterialCondition", "MaximumMaterialCondition" : "MaximumMaterialCondition", "RegardlessOfFeatureSize" : "RegardlessOfFeatureSize", "Basic" : "Basic"});

export default SPLM;